import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

export class Snackbars {
  public static infoSnackBar(message: string, snackBar: MatSnackBar) {
    Snackbars.openSnackbar(message, 'info', snackBar);
  }

  public static errorSnackBar(message: string, snackBar: MatSnackBar) {
    Snackbars.openSnackbar(message, 'error', snackBar);
  }

  /**
   * Opens a snackbar
   * type one of:
   * - error
   * - info
   */
  private static openSnackbar(
    message: string,
    type: string,
    snackBar: MatSnackBar
  ) {
    let classPanel;
    switch (type) {
      case 'error':
        classPanel = ['red-snackbar'];
        break;
      case 'info':
        classPanel = ['success-snackbar'];
        break;
      default:
        classPanel = ['success-snackbar'];
    }

    snackBar.open(message, '', {
      duration: 5000,
      panelClass: classPanel,
      verticalPosition: 'top',
    });
  }
}
